import * as React from 'react';
import '../../_assets/css/file.css';
import axios from 'axios';

import { baseURL, baseURL_Radio_Compaign } from '../../_helpers';
import { Card, CardBody, Col, Button } from 'reactstrap';
import { Redirect } from 'react-router-dom';
import PhoneOutlineIcon from 'mdi-react/PhoneOutlineIcon';
import Input from 'react-phone-number-input/input'

export class Deallocate extends React.Component {

    constructor(props) {
        super(props)
        this.onSubmit = this.onSubmit.bind(this);
        this.state = {
            phone_number: '',
            showError: false,
            email_address: '',
            userDetail: false,
            isShowError: false,
        }

        localStorage.setItem("phone_2", null);
    }

    onSubmit(e) {
        e.preventDefault();
        let phone_number;
        if (this.state.phone_number != '') {
            localStorage.setItem('phone_2', "false")
            phone_number = this.state.phone_number.replaceAll("+", "");
        } else {
            localStorage.setItem('phone_2', "true")
            phone_number = this.state.email_address
        }

        let formData = {
            "customer_id": phone_number
        }
        this.setState({ isLoading: true });
        var sha512 = require('js-sha512');
        let signature = sha512(phone_number + 'P@s5w0rd_5@lt')
        axios.post(baseURL_Radio_Compaign + 'luckybox/deallocate_ticket', formData, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "signature": signature
            },
        }).then((response) => {
            if (response.data.code = "0000") {

                alert("success")
                this.setState({
                    statusMessage: response.data.message,
                    isShowError: true, isLoading: false, showError: false,

                });
                setTimeout(() => {
                    this.setState({
                        statusMessage: response.data.message,
                        phone_number: '',
                        email_address: '',
                        userDetail: true,
                        isShowError: true, isLoading: false, showError: false,
                    });
                }, 1000);
            } else {
                this.setState({ statusMessage: response.data.message, email_address: '', 
                phone_number: '', userDetail: false, showError: true, isShowError: false, isLoading: false });
            }
        }).catch(error => {
            console.log('bayoo', error.response)
            this.setState({
                showError: true,
                isShowError: false,
                phone_number: '',
                email_address: '',
                userDetail: false,
                statusMessage: error.response.data.message,
                submitted: true,
                isLoading: false
            });
        });


    }
    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    render() {
        const { showComponent } = this.state;
        const { hideComponent, userDetail } = this.state;

        return (
            <div className="pcoded-main-container">
                {!hideComponent && (
                    <>
                        <Col md={12} lg={12}>
                            <Card>
                                <CardBody>
                                    <div className="card__title">
                                        <h5 className="bold-text">Deallocate live jackpot ticket for lost bet</h5>
                                    </div>
                                    {this.state.showError ? <div style={{ color: 'red' }}>
                                        {this.state.statusMessage}
                                    </div> : null}<br></br>
                                    {this.state.isShowError ? (
                                        <div color="success" style={{ fontSize: "13px", color: "green" }}>

                                            {this.state.statusMessage}

                                        </div>
                                    ) : null}<br></br>
                                    <form className="col-md-8 offset-md-2" onSubmit={this.onSubmit}>


                                        <span className="form__form-group-label">Phone No.</span>

                                        <div className="form__form-group-field">
                                            <div className="form__form-group-icon">
                                                <PhoneOutlineIcon />
                                            </div>
                                            <Input
                                                country="NG"
                                                international
                                                withCountryCallingCode
                                                required
                                                className="form-control"
                                                placeholder="Ваш телефон"
                                                name="phone_number"
                                                id="input"
                                                value={this.state.phone_number}
                                                onChange={value => this.setState({ phone_number: value })} />
                                        </div>


                                        <b>OR</b>

                                        <br />

                                        <span className="form__form-group-label">Email Address</span>
                                        <div className="form__form-group-field"><div className="form__form-group-icon">
                                            <Card />
                                        </div>

                                            <input id="input" type="text" className="form-control input-md"
                                                name="email_address" placeholder="Enter Email Address"
                                                value={this.state.email_address} onChange={this.handleChange} />

                                        </div>


                                        <br />
                                        <div className="col-12">
                                            <br /><br />
                                            <Button type="submit" outline color="primary" className="float-right" >
                                                {this.state.isLoading ? "Please Wait..." : "Deallocate"}
                                            </Button> &nbsp;&nbsp;&nbsp;
                                        </div>
                                    </form>
                                </CardBody>
                            </Card>
                        </Col>
                    </>

                )
                }

            </div>
        )

    }

}
